import Grid from "@material-ui/core/Grid";
import React from "react";
import { FlyerDetailPageTabPageDetailPositionsProps } from "./flyer-detail-page-tab-page-detail-positions.props";

export const FlyerDetailPageTabPageDetailPositions = (
  props: FlyerDetailPageTabPageDetailPositionsProps
) => (
  <Grid item={true} xs={2} sm={2} md={2} lg={2}>
    {((props.numberOfPositions as number) > 0 ? ((props.numberOfPositions as number) > 1 ? props.numberOfPositions +" Positions" : "1 Position") : "No Positions")}
  </Grid>
);
